import { cn } from '@/lib/utils';

export default function StatusBadge({ status }) {
  const variants = {
    OK: {
      className:
        'bg-secondary text-secondary-foreground border border-secondary/30 shadow-sm',
      label: 'En hora',
    },
    Retraso: {
      className: 'bg-warning/25 text-foreground border border-warning/40 shadow-sm',
      label: 'Retraso',
    },
    'Sin datos': {
      className: 'bg-muted text-muted-foreground border border-border/80',
      label: 'Sin datos',
    },
  };

  const variant = variants[status] || variants['Sin datos'];

  return (
    <div
      className={cn(
        'inline-flex min-w-[5.5rem] items-center justify-center rounded-full px-3 py-1 text-[10px] font-extrabold uppercase tracking-widest',
        variant.className
      )}
      data-testid="status-badge"
    >
      {variant.label}
    </div>
  );
}
